import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BackToMenu } from "../features/menu/back-link";
import { CategoryFormView } from "../features/menu/category-form";
import { useInPanes } from "../features/menu/panes";
import { Require } from "../features/require";

export const Route = createFileRoute("/menu/categories/new")({ component: Page });

function Page() {
	const navigate = useNavigate();
	const inPanes = useInPanes();
	return (
		<Require permission="menu.edit">
			<div className="max-w-3xl">
				<CategoryFormView
					categoryId={null}
					back={<BackToMenu to="/menu/categories" />}
					onSaved={(category) =>
						void navigate(
							inPanes
								? { to: "/menu", search: { category: category.id } }
								: { to: "/menu/categories" },
						)
					}
					onDeleted={() => void navigate({ to: "/menu/categories" })}
				/>
			</div>
		</Require>
	);
}
